import React from 'react';
import { BsFacebook, BsTwitter, BsInstagram, BsGithub } from 'react-icons/bs';
import './footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <p>&copy; {new Date().getFullYear()} Kabita Aryal. All rights reserved.</p>
                <ul className="footer-links">
                    <li><a href="/privacy-policy">Privacy Policy</a></li>
                    <li><a href="/terms-of-service">Terms of Service</a></li>
                    <li><a href="/contact">Contact Us</a></li>
                </ul>
                <div className="social-media-icons">
                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                        <BsFacebook size={24} />
                    </a>
                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                        <BsTwitter size={24} />
                    </a>
                    <a href="https://www.instagram.com/kabita.aryal.1675/" target="_blank" rel="noopener noreferrer">
                        <BsInstagram size={24} />
                    </a>
                    <a href="https://github.com" target="_blank" rel="noopener noreferrer">
                        <BsGithub size={24} />
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;